const mapFox: any = {
  name: 'fox',
  details: {
    parts: [
      { id: 'kvet', label: 'Květ', comment: 'Trefa, bílý konec ocasu lišky je květ.', isCorrect: true },
      { id: 'ohanka', label: 'Oháňka', comment: 'Nejsi ty myslivec? Opravdu je to ocas.', isCorrect: true },
      { id: 'morda', label: 'Morda', comment: 'Ty jsi znalec! Morda jsou ústa lišky.', isCorrect: true },
      { id: 'svetla', label: 'Světla', comment: 'Dobrý, fakt to jsou oči.', isCorrect: true },
      { id: 'slechy', label: 'Slechy', comment: 'Výborně, opravdu to jsou uši.', isCorrect: true },
      { id: 'pirko', label: 'Pírko', comment: null, isCorrect: false },
      { id: 'zrcatko', label: 'Zrcátko', comment: null, isCorrect: false },
      { id: 'vetrnik', label: 'Větrník', comment: null, isCorrect: false },
    ],
    errorComments: [
      'Nene, zkus to jinak.',
      'Vedle jak ta jedle.',
      'Kdepak, zkus to jinak.',
      'Prach a broky, to není ono.',
    ],
  },
  areas: [
    {
      id: '667d73b1-4583-4080-ab6b-5759f25440bb',
      title: 'kvet',
      shape: 'poly',
      name: 'kvet',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        7, 1458, 278, 1331, 341, 1363, 349, 1386, 355, 1416, 339, 1487, 302, 1530, 299, 1554, 233, 1503, 209, 1514, 182,
        1503, 102, 1479, 89, 1490,
      ],
      // "polygon": [
      //   [7,1458],[278,1331],[341,1363],[349,1386],[355,1416],[339,1487],[302,1530],[299,1554],[233,1503],[209,1514],[182,1503],[102,1479],[89,1490]
      // ]
    },
    {
      id: '667d73b1-4583-4080-ab6b-5759f25442bb',
      title: 'ohanka',
      shape: 'poly',
      name: 'ohanka',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        299, 1315, 373, 1296, 440, 1286, 535, 1296, 607, 1309, 721, 1296, 764, 1278, 931, 1246, 1003, 1264, 1059, 1230,
        1128, 1243, 1224, 1246, 1245, 1291, 1213, 1339, 1200, 1392, 1168, 1471, 1157, 1498, 735, 1533, 583, 1546, 355,
        1548, 310, 1551, 347, 1503, 365, 1456, 368, 1394,
      ],
    },
    {
      id: '667d73b1-4583-4080-ab6b-5759f25442b1',
      title: 'morda',
      shape: 'poly',
      name: 'morda',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        1984, 683, 1938, 677, 1888, 730, 1851, 760, 1800, 773, 1774, 773, 1790, 799, 1832, 799, 1880, 773, 1949, 712,
      ],
    },
    {
      id: '667d73b1-4583-4080-ab6n-5759f25442b2',
      title: 'svetla',
      shape: 'poly',
      name: 'svetla',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        1744, 550, 1771, 574, 1819, 579, 1869, 576, 1875, 555, 1925, 544, 1944, 571, 1962, 598, 1907, 616, 1872, 624,
        1808, 598, 1776, 608, 1739, 614, 1737, 579,
      ],
    },
    {
      id: '667d73b1-4583-4080-ab62-5759f25442b3',
      title: 'slechy',
      shape: 'poly',
      name: 'slechy',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        1691, 510, 1689, 472, 1673, 456, 1667, 390, 1651, 334, 1638, 239, 1654, 209, 1713, 252, 1763, 287, 1792, 321,
        1819, 345, 1856, 340, 1912, 340, 1952, 276, 1994, 225, 2042, 225, 2077, 292, 2085, 398, 2090, 456, 2055, 499,
        1965, 465, 1938, 428, 1920, 380, 1885, 377, 1830, 375, 1784, 425, 1734, 491,
      ],
    },
  ],
}

const mapPheasant: any = {
  name: 'pheasant',
  details: {
    parts: [
      { id: 'svetlo', label: 'Světlo', comment: 'Výborně, opravdu je to oko.', isCorrect: true },
      { id: 'klovec', label: 'Klovec', comment: 'Trefa! Klovec je fakt zobák.', isCorrect: true },
      {
        id: 'ruzky',
        label: 'Růžky',
        comment: 'Nejsi ty myslivec? Těmto pírkům se opravdu říká růžky.',
        isCorrect: true,
      },
      { id: 'klin', label: 'Klín', comment: 'Ty musíš být znalec! Klín je fakt ocas.', isCorrect: true },
      { id: 'obojek', label: 'Obojek', comment: 'Správně.', isCorrect: true },
      { id: 'pirko', label: 'Pírko', comment: null, isCorrect: false },
      { id: 'slechy', label: 'Slechy', comment: null, isCorrect: false },
      { id: 'ohanka', label: 'Oháňka', comment: null, isCorrect: false },
    ],
    errorComments: [
      'Nene, zkus to jinak.',
      'Vedle jak ta jedle.',
      'Kdepak, zkus to jinak.',
      'Prach a broky, to není ono.',
    ],
  },
  areas: [
    {
      id: '667d73b1-4583-4080-ab6b-5759f25440bb',
      title: 'svetlo',
      shape: 'circle',
      name: 'svetlo',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [2393, 538, 52],
    },
    {
      id: '667d73b1-4583-4080-ab6b-5759f25442bb',
      title: 'klovec',
      shape: 'poly',
      name: 'klovec',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [2499, 510, 2537, 547, 2568, 598, 2562, 641, 2524, 613, 2468, 616, 2437, 601, 2462, 560, 2474, 526],
    },
    {
      id: '667d73b1-4583-4080-ab6b-5759f25442b1',
      title: 'ruzky',
      shape: 'circle',
      name: 'ruzky',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [2249, 519, 59],
    },
    {
      id: '667d73b1-4583-4080-ab6n-5759f25442b2',
      title: 'klin',
      shape: 'poly',
      name: 'klin',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [
        1668, 1355, 1427, 1180, 1249, 1070, 1118, 1017, 1030, 1001, 949, 1014, 923, 1017, 811, 1017, 692, 1023, 582,
        1048, 495, 1086, 382, 1158, 357, 1189, 338, 1220, 507, 1155, 598, 1136, 840, 1120, 671, 1430, 900, 1142, 1119,
        1229, 1221, 1289, 1362, 1370, 1452, 1439, 1531, 1517, 1668, 1399, 1659, 1380,
      ],
    },
    {
      id: '667d73b1-4583-4080-ab62-5759f25442b3',
      title: 'obojek',
      shape: 'poly',
      name: 'obojek',
      preFillColor: 'rgba(24, 90, 255, 0.35)',
      fillColor: 'rgba(21, 190, 255, 0.5)',
      strokeColor: 'rgba(240, 90, 255, 0.5)',
      coords: [2286, 851, 2280, 895, 2286, 945, 2349, 960, 2446, 942, 2505, 892, 2459, 863, 2380, 860],
    },
  ],
}

export const Game2Map: any = {
  welcome: [
    'Myslivci, stejně jako ostatní odborníci, používají při komunikaci speciální řeč – tzv. mysliveckou mluvu. Mysliveckou mluvou mají pojmenované i  části těla nebo způsob chování zvěře.',
    'Dokážeš správně přiřadit názvy části těla v myslivecké mluvě? Vyber pět z osmi názvů, které máš na výběr.',
  ],
  fox: mapFox,
  pheasant: mapPheasant,
}
